import { createSlice } from "@reduxjs/toolkit";

const localChalanSlice = createSlice({
  name: "localChalanSlice",
  initialState: {
    localChalan: [],
    status: "ok",
  },
  reducers: {  
    setlocalChalanDetail: (state, action) => {
      state.localChalan = action.payload;
    },
    editLocalChalanDetail: (state, action) => {},
    validateLocalChalanDetail: (state, action) => {
      return;
    },
  },
});

export default localChalanSlice.reducer;

export const {
  setlocalChalanDetail,
  editLocalChalanDetail,
  validateLocalChalanDetail,
} = localChalanSlice.actions;
